import React from 'react';

export const VerifyField = ({ value, onChange, testid }) => (
  <div className="mt-4">
    <label className="block text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">Collection postcode or booking email</label>
    <input value={value} onChange={(e) => onChange(e.target.value)} maxLength={120} autoComplete="off" placeholder="e.g. E14 9BF" required className="w-full h-11 rounded-md border border-slate-200 bg-white px-3 text-sm" data-testid={testid} />
    <p className="text-[11px] text-slate-500 mt-1">So we know it's really you making this change.</p>
  </div>
);
